//Custom components
import { countDuplicateStringsInArray } from '@/utils';
import Card from '../../UI/Card/index.tsx';

//Assets and Miscellaneous

export default function DevelopmentGoalSummaryWidget({ data }: { data: string[] }) {
  const developmentGoalsSummary: { name: string; count: number }[] = countDuplicateStringsInArray(data);

  return (
    <Card title='Development Goals Summary'>
      <div className='h-96 overflow-scroll'>
        {developmentGoalsSummary?.map((s: { name: string; count: number }) => (
          <div key={s?.name} className='flex justify-between gap-4 py-5 px-10 border-b'>
            <span>{s?.name}</span>
            <span className='text-xl font-bold'>{s?.count}</span>
          </div>
        ))}
      </div>
    </Card>
  );
}
